module.exports = __webpack_public_path__ + "img/district.a42ebc82.svg";